
import { inject, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { InjectionKeys } from '@/constants';
import { Auth0Manager } from '@/auth';

export default {
  name: 'NavBar',
  components: {},
  inheritAttrs: false,
  setup() {
    const auth = inject(InjectionKeys.Auth) as Auth0Manager;
    const router = useRouter();
    const isMenuVisible = ref(false);
    const homeUrl = computed((): string => {
      return auth.state.isAuthenticated ? '/admin' : '/';
    });

    const login = () => {
      auth.loginWithRedirect({
        appState: { targetUrl: '/admin' }
      });
    };

    const logout = () => {
      auth.logout({ returnTo: window.location.origin });
      router.push({ path: '/' });
    };

    const toggleMenu = () => {
      isMenuVisible.value = !isMenuVisible.value;
    };

    const handleMouseLeave = () => {
      isMenuVisible.value = false;
    };

    return {
      ...auth.state,
      homeUrl,
      login,
      logout,
      isMenuVisible,
      toggleMenu,
      handleMouseLeave
    };
  }
};
